import {Base, model, hasMany, endpoint} from '@scoutgg/ftw/source/lib/model'
import ftw from '@scoutgg/ftw/source/services/config'

@model('User')
@hasMany('matches')
@endpoint('users', {root: '/api'})
export class User extends Base {
  static get current() {
    if(!ftw.token) return console.warn('Current user not found')
    var obj = JSON.parse(atob(ftw.token.split('.')[1]))
    return this.instance(obj.sub, {
      email: obj.name,
    })
  }
}
